var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"height":"100vh"}},[_c('iframe',{staticClass:"fill-height",staticStyle:{"border":"0px","width":"100%","height":"100%"},attrs:{"src":_vm.src}})])])}
var staticRenderFns = []

export { render, staticRenderFns }